/*
* Column: bind clone events
*
* @since 2.0
*/
import { COLUMN_EVENTS } from "../column";
export const initClone = (column) => {
    column.getElement().querySelectorAll('.clone-button').forEach(element => {
        element.addEventListener('click', e => {
            e.preventDefault();
            if (!column.isOriginal()) {
                column.events.emit(COLUMN_EVENTS.CLONE);
            }
        });
    });
};
